import request from '../utils/request'
export const queryCompanyRiskMaps = (data) => {
  return request({
    url: '/feedback/list',
    method: 'post',
    data
  })
}


export const deletes = (data) => {
    return request({
      url: '/feedback/delete',
      method: 'post',
      data
    })
  }


  export const boardlist = (data) => {
      return request({
        url: '/board/list',
        method: 'post',
        data
      })
    }
    export const boarddelete = (data) => {
        return request({
          url: '/board/delete',
          method: 'post',
          data
        })
      }
